var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-form",
    {
      attrs: { size: "small" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSave.apply(null, arguments)
        },
      },
    },
    [
      _c("sui-header", { tag: "h3" }, [_vm._v("Client Agreement Profile")]),
      _c(
        "sui-grid",
        [
          _c(
            "sui-grid-row",
            [
              _c("sui-grid-column", { attrs: { width: 8 } }, [
                _vm.user.profile.profile_type === 2
                  ? _c(
                      "div",
                      [
                        _c(
                          "sui-form-fields",
                          { attrs: { "equal-width": "" } },
                          [
                            _c(
                              "sui-form-field",
                              [
                                _c("label", [_vm._v("Client")]),
                                _c("sui-dropdown", {
                                  attrs: {
                                    selection: "",
                                    floating: "",
                                    direction: "downward",
                                    placeholder: "Client",
                                    options: _vm.clients,
                                  },
                                  model: {
                                    value: _vm.clientId,
                                    callback: function ($$v) {
                                      _vm.clientId = $$v
                                    },
                                    expression: "clientId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "sui-form-field",
                              [
                                _c("label", [_vm._v("Client Type")]),
                                _c("sui-dropdown", {
                                  attrs: {
                                    placeholder: "Select form",
                                    selection: "",
                                    floating: "",
                                    options: _vm.formTypeOptions,
                                  },
                                  model: {
                                    value: _vm.agreement.Form_Type__c,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.agreement,
                                        "Form_Type__c",
                                        $$v
                                      )
                                    },
                                    expression: "agreement.Form_Type__c",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("sui-dropdown", {
                          staticStyle: { "margin-bottom": "12px !important" },
                          attrs: {
                            placeholder: "Select form type",
                            selection: "",
                            floating: "",
                            options: _vm.formTypeOptions,
                          },
                          model: {
                            value: _vm.agreement.Form_Type__c,
                            callback: function ($$v) {
                              _vm.$set(_vm.agreement, "Form_Type__c", $$v)
                            },
                            expression: "agreement.Form_Type__c",
                          },
                        }),
                      ],
                      1
                    ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "sui-grid",
        [
          this.formType === "Individual Client"
            ? _c(
                "sui-grid-row",
                [
                  _c("ClientInput", {
                    attrs: {
                      agreement: _vm.agreement,
                      states: _vm.states,
                      mailPreferenceOptions: _vm.mailPreferenceOptions,
                      employmentStatusOptions: _vm.employmentStatusOptions,
                      submitted: _vm.submitted,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          this.formType === "Joint Clients"
            ? _c("JointClientInput", {
                attrs: {
                  agreement: _vm.agreement,
                  states: _vm.states,
                  mailPreferenceOptions: _vm.mailPreferenceOptions,
                  employmentStatusOptions: _vm.employmentStatusOptions,
                  submitted: _vm.submitted,
                },
              })
            : _vm._e(),
          _vm.agreement.Form_Type__c
            ? _c(
                "sui-grid-row",
                [
                  _c("sui-grid-column", [
                    _c(
                      "div",
                      [
                        _c("sui-button", {
                          attrs: {
                            basic: "",
                            type: "button",
                            color: "grey",
                            size: "small",
                            content: "Cancel",
                          },
                        }),
                        _c("sui-button", {
                          attrs: {
                            primary: "",
                            size: "small",
                            content: "Save",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }